export const MOTORWAY_PAY_FAQ_LINK = 'https://help.dealers.motorway.co.uk/hc/en-gb/sections/9921602186652-Motorway-Pay';
export const MODULR_UK_SAFEGUARDING_EXPLANATION_LINK = 'https://www.modulrfinance.com/uk-safeguarding-information';
export interface MotorwayPayModulrProps {
	displayAs: 'signedOut' | 'signedInWithPayment' | 'signedInWithoutPayment';
}
